import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, allowMustChange = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white/40 text-sm tracking-widest uppercase">
        Authenticating…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Force users with a temp password to set a new one before doing anything else.
  if (user.must_change_password && !allowMustChange && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/feed" replace />;
  return children;
}
